import { ServiceRequest } from '../types';

export const CITY_MATCH_RADIUS_KM = 30;

export type Coordinates = {
  latitude: number;
  longitude: number;
};

export type CurrentJobLocation = Coordinates & {
  city?: string;
  area?: string;
};

type CityCenter = Coordinates & {
  city: string;
};

export const ZIMBABWE_CITY_CENTERS: CityCenter[] = [
  { city: 'Harare', latitude: -17.8249, longitude: 31.0530 },
  { city: 'Bulawayo', latitude: -20.1325, longitude: 28.6265 },
  { city: 'Chitungwiza', latitude: -18.0127, longitude: 31.0756 },
  { city: 'Mutare', latitude: -18.9707, longitude: 32.6709 },
  { city: 'Gweru', latitude: -19.4515, longitude: 29.8170 },
  { city: 'Kwekwe', latitude: -18.9281, longitude: 29.8149 },
  { city: 'Kadoma', latitude: -18.3333, longitude: 29.9167 },
  { city: 'Masvingo', latitude: -20.0744, longitude: 30.8328 },
  { city: 'Chinhoyi', latitude: -17.3667, longitude: 30.2000 },
  { city: 'Marondera', latitude: -18.1853, longitude: 31.5519 },
  { city: 'Norton', latitude: -17.8833, longitude: 30.7000 },
  { city: 'Ruwa', latitude: -17.8833, longitude: 31.2500 },
  { city: 'Chegutu', latitude: -18.1302, longitude: 30.1407 },
  { city: 'Zvishavane', latitude: -20.3267, longitude: 30.0665 },
  { city: 'Bindura', latitude: -17.3019, longitude: 31.3306 },
  { city: 'Beitbridge', latitude: -22.2167, longitude: 30.0000 },
  { city: 'Victoria Falls', latitude: -17.9243, longitude: 25.8560 },
  { city: 'Hwange', latitude: -18.3645, longitude: 26.4988 },
  { city: 'Kariba', latitude: -16.5167, longitude: 28.8000 },
  { city: 'Rusape', latitude: -18.5278, longitude: 32.1284 },
  { city: 'Redcliff', latitude: -19.0333, longitude: 29.7833 },
  { city: 'Shurugwi', latitude: -19.6702, longitude: 30.0059 },
  { city: 'Gwanda', latitude: -20.9362, longitude: 29.0067 },
  { city: 'Plumtree', latitude: -20.4833, longitude: 27.8167 },
  { city: 'Chipinge', latitude: -20.1883, longitude: 32.6236 },
  { city: 'Murehwa', latitude: -17.6432, longitude: 31.7840 },
  { city: 'Karoi', latitude: -16.8099, longitude: 29.6925 },
  { city: 'Chiredzi', latitude: -21.0500, longitude: 31.6667 },
  { city: 'Lupane', latitude: -18.9315, longitude: 27.8069 },
  { city: 'Mvurwi', latitude: -17.0333, longitude: 30.8500 },
  { city: 'Mutoko', latitude: -17.3970, longitude: 32.2268 },
  { city: 'Nyanga', latitude: -18.2167, longitude: 32.7500 },
  { city: 'Mazowe', latitude: -17.5167, longitude: 30.9667 },
  { city: 'Guruve', latitude: -16.6500, longitude: 30.7000 },
  { city: 'Mhangura', latitude: -16.8939, longitude: 30.1683 },
  { city: 'Shamva', latitude: -17.3113, longitude: 31.5756 },
  { city: 'Binga', latitude: -17.6167, longitude: 27.3333 },
  { city: 'Buhera', latitude: -19.3333, longitude: 31.4333 },
  { city: 'Gokwe', latitude: -18.2167, longitude: 28.9333 },
  { city: 'Banket', latitude: -17.3833, longitude: 30.4000 },
  { city: 'Epworth', latitude: -17.8900, longitude: 31.1475 },
  { city: 'Chimanimani', latitude: -19.8000, longitude: 32.8667 },
  { city: 'Makoni', latitude: -18.5333, longitude: 32.1167 },
  { city: 'Mutasa', latitude: -18.6167, longitude: 32.6667 },
  { city: 'Muzarabani', latitude: -16.3833, longitude: 31.0000 },
  { city: 'Mbire', latitude: -16.1000, longitude: 30.2500 },
  { city: 'Mount Darwin', latitude: -16.7833, longitude: 31.5833 },
  { city: 'Rushinga', latitude: -16.6333, longitude: 32.0833 },
  { city: 'Chikomba', latitude: -19.0167, longitude: 31.2500 },
  { city: 'Goromonzi', latitude: -17.7667, longitude: 31.3500 },
  { city: 'Hwedza', latitude: -18.6167, longitude: 31.5833 },
  { city: 'Mudzi', latitude: -17.0667, longitude: 32.3000 },
  { city: 'Seke', latitude: -18.0667, longitude: 31.1167 },
  { city: 'Uzumba-Maramba-Pfungwe', latitude: -17.1333, longitude: 32.0000 },
  { city: 'Hurungwe', latitude: -16.4833, longitude: 29.5667 },
  { city: 'Makonde', latitude: -17.2167, longitude: 30.0833 },
  { city: 'Mhondoro-Ngezi', latitude: -18.5167, longitude: 30.3667 },
  { city: 'Sanyati', latitude: -17.9500, longitude: 29.3000 },
  { city: 'Zvimba', latitude: -17.4333, longitude: 30.3500 },
  { city: 'Bikita', latitude: -20.0833, longitude: 31.6333 },
  { city: 'Chivi', latitude: -20.3000, longitude: 30.5000 },
  { city: 'Gutu', latitude: -19.6500, longitude: 31.1667 },
  { city: 'Mwenezi', latitude: -21.4667, longitude: 30.7333 },
  { city: 'Zaka', latitude: -20.3333, longitude: 31.4500 },
  { city: 'Bubi', latitude: -19.3333, longitude: 28.6667 },
  { city: 'Nkayi', latitude: -19.0000, longitude: 28.9000 },
  { city: 'Tsholotsho', latitude: -19.7667, longitude: 27.7667 },
  { city: 'Umguza', latitude: -19.6333, longitude: 28.1667 },
  { city: 'Bulilima', latitude: -20.4000, longitude: 27.6000 },
  { city: 'Insiza', latitude: -20.4500, longitude: 29.2167 },
  { city: 'Mangwe', latitude: -20.8833, longitude: 27.8167 },
  { city: 'Matobo', latitude: -21.1333, longitude: 28.5167 },
  { city: 'Umzingwane', latitude: -20.3167, longitude: 28.9167 },
  { city: 'Chirumhanzu', latitude: -19.3167, longitude: 30.4833 },
  { city: 'Gokwe North', latitude: -17.5000, longitude: 28.9500 },
  { city: 'Gokwe South', latitude: -18.2167, longitude: 28.9333 },
  { city: 'Mberengwa', latitude: -20.4833, longitude: 29.9167 }
].sort((a, b) => a.city.localeCompare(b.city));

const normalize = (value?: string | null) =>
  (value || '').trim().toLowerCase().replace(/\s+/g, ' ');

const radians = (value: number) => (value * Math.PI) / 180;

export const distanceKm = (a: Coordinates, b: Coordinates) => {
  const earthKm = 6371;
  const latDelta = radians(b.latitude - a.latitude);
  const lonDelta = radians(b.longitude - a.longitude);
  const lat1 = radians(a.latitude);
  const lat2 = radians(b.latitude);

  const h =
    Math.sin(latDelta / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(lonDelta / 2) ** 2;

  return earthKm * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
};

export const findCityInAddress = (address?: string | null) => {
  const normalAddress = normalize(address);
  return ZIMBABWE_CITY_CENTERS.find((place) =>
    normalAddress.includes(normalize(place.city)),
  )?.city;
};

export const getNearestZimbabweCity = (
  coordinates?: Coordinates | null,
  maxDistanceKm = CITY_MATCH_RADIUS_KM,
) => {
  if (!coordinates) return undefined;

  const nearest = ZIMBABWE_CITY_CENTERS
    .map((place) => ({
      ...place,
      distanceKm: distanceKm(coordinates, place),
    }))
    .sort((a, b) => a.distanceKm - b.distanceKm)[0];

  return nearest && nearest.distanceKm <= maxDistanceKm ? nearest : undefined;
};

export const getRequestCity = (
  request?: Pick<ServiceRequest, 'address' | 'latitude' | 'longitude'> | null,
) => {
  const addressCity = findCityInAddress(request?.address);
  if (addressCity) return addressCity;

  if (request?.latitude && request?.longitude) {
    return getNearestZimbabweCity({
      latitude: request.latitude,
      longitude: request.longitude,
    })?.city;
  }

  return undefined;
};

export const getCurrentLocationCity = (location?: CurrentJobLocation | null) =>
  location?.city || getNearestZimbabweCity(location)?.city;

export const isRequestInCurrentLocation = (
  request: Pick<ServiceRequest, 'address' | 'latitude' | 'longitude'>,
  currentLocation?: CurrentJobLocation | null,
) => {
  const currentCity = getCurrentLocationCity(currentLocation);
  const requestCity = getRequestCity(request);

  if (!currentCity || !requestCity) {
    return {
      matches: false,
      currentCity,
      requestCity,
    };
  }

  return {
    matches: normalize(currentCity) === normalize(requestCity),
    currentCity,
    requestCity,
  };
};
